import { API_BASE_URL } from "@/config/constants";

const PROTECTION_BYPASS =
  import.meta.env.VITE_VERCEL_PROTECTION_BYPASS ?? undefined;

/**
 * Wrapper around fetch that prepends API_BASE_URL and injects
 * Vercel Deployment Protection bypass header when configured.
 */
export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);

  if (PROTECTION_BYPASS) {
    headers.set("x-vercel-protection-bypass", PROTECTION_BYPASS);
  }

  return fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers,
    credentials: "include",
  });
}
